import React, { useContext } from 'react';
import { AuthContext } from '../authContext/context';
import { checkPermission } from '../utils/checkPermissions';
import { Typography, Box } from '@mui/material';
import BreadcrumbsWrapper from './breadcrumbs';

const PermissionWrapper = ({
  category,
  permission,
  children,
  pageTitle = 'Page',
  breadcrumbs = []
}) => {
  const authCtx = useContext(AuthContext);
  const userPermissions = authCtx.permissions;

  const hasPermission = checkPermission(userPermissions, category, permission);

  if (!hasPermission) {
    return (
      <>
        <BreadcrumbsWrapper items={breadcrumbs} />
        <br />
        <div className='page-header pb-3'>
          <h1 className='mt-0 mb-0'>{pageTitle}</h1>
        </div>
        <Box className='page-top-formview mb-3 text-center'>
          <Typography variant="h6" color="text.secondary">
            You do not have permission to access this section.
          </Typography>
        </Box>
      </>
    );
  }

  return (
    <>
      {breadcrumbs.length > 0 && (
        <>
          <BreadcrumbsWrapper items={breadcrumbs} />
          <br />
        </>
      )}
      {children}
    </>
  );
};

export default PermissionWrapper;